import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const AddressFieldNl = React.lazy(() => import('../components/address-field-nl'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(AddressFieldNl);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,

    config: {
      validators: ['mandatory'],
    },
  };
}
